import React from "react";
import styled, { keyframes } from "styled-components";
import { useSelector } from "react-redux";
import { viewJobSelector } from "../ViewJob/selector";

import { MdOutlineClose } from "react-icons/md";

const ModalGoTo = (props) => {
  const { requestData } = useSelector(viewJobSelector);
  return (
    <Wrapper>
      <MainContent>
        <Summary>
          <Header>
            <label htmlFor='job-summary'>{requestData?.viewJobTitle}</label>
            <button onClick={props.showHide} className="btn btn-danger">Close</button>
          </Header>
          {props.children}
          {/* <GoToBackContainer> */}
            {/* <GoToBack   /> */}
            {/* <BtnContainer>
              {requestData?.save && <SaveBtn onClick={props.save}>
                <button>Save</button>
              </SaveBtn> */}
              {/* } */}
              {/* <GoToBtn onClick={props.showHide}>
                <AiFillBackward className="go-btn-icon" />
                <button>Back</button>
              </GoToBtn> */}
            {/* </BtnContainer>
          </GoToBackContainer> */}
          <BtnContainer>
            <button onClick={props.showHide} className="btn btn-danger">Close</button>
            {requestData?.save && <button onClick={props.save} className="btn btn-primary ms-2">Save and view candidates</button>}
          </BtnContainer>
        </Summary>
      </MainContent>
    </Wrapper>
  );
};

const appear = keyframes`
0%{
  opacity: 1;
  transform: translateY(-10px)
}
`

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 9999;
  overflow-x: hidden;
  display: flex;
  height: 100%;
  width: 100%;
  animation: ${appear} 0.25s linear;
`;
const MainContent = styled.div`
  width: 90%;
  height: 90%;
  background-color: #fff;
  display: flex;
  margin: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  border-radius: 4px;
  position: relative;
`;

const Summary = styled.div`
  height: 100%;
  width: 100%;
`;
const BtnContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-bottom: 1rem ;
  padding-right: 25px;
`
const Header = styled.div`
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.25rem;

  & > svg {
    cursor: pointer;
    &:hover {
      color: rgba(0, 0, 0, 0.4);
      transition: all 0.1s linear;
    }
  }
`;

// const GoToBackContainer = styled.div`
//   position: absolute;
// `;
// const BtnContainer = styled.div`
// display: flex;
//      position: fixed;
//   /* bottom: 4rem;
//   right: 4rem; */
//   top: 80%;
//   right: 15%;
//   z-index: 999;
//   & > div {
//     height: 2.5rem;
//   width: 7rem;
//   border-radius: 5px;

//   }
// `
// const goToBack = keyframes`
//  0% {
//       transform: translateX(-0.25rem);
//     }
//     100% {
//       transform: translateX(0.25rem);
//     }
// `;
// const SaveBtn = styled.div`

//   /* border-radius: 50%; */
//   background: #20851a;
//   /* box-shadow: #0a66c2 0px 0px 16px; */
//   box-shadow: #20851a 0px 3px 5px;
//   color: #fff;
//   /* position: fixed; */
//   /* bottom: 4rem;
//   right: 4rem; */
//   /* top: 80%;
//   right: 25%; */
//   margin: 0 3px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   & > button {
//     letter-spacing: 1px;
//   }
// `;
// const GoToBtn = styled.div`
//   z-index: 999;
//   /* border-radius: 50%; */
//   background: #20851a;
//   /* box-shadow: #0a66c2 0px 0px 16px; */
//   box-shadow: #20851a 0px 3px 5px;
//   color: #fff;
//   margin: 0 3px;
 
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   & > svg {
//     animation: ${goToBack} 0.75s linear infinite alternate-reverse;
//   }
//   & > button {
//     margin: 0 4px;
//     letter-spacing: 1px;
//   }
// `;
export default ModalGoTo;
